export default "__VITE_ASSET__DK4RfFy3__$_?assetResource__"